import { createContext } from 'react';

const SubmitContext = createContext<(() => Promise<boolean>) | null>(null);
export default SubmitContext;
